export class Failure {
  /**
   * @type {false}
   */
  success = false;
  errorMessage = '';

  constructor(errorMessage) {
    this.errorMessage = errorMessage;
  }
}
